import { PortalInfo } from '../model/portal-info.model';
import { UntypedFormGroup } from '@angular/forms';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionService, User } from '@edl-development/edl-common';

@Component({
    selector: 'administration',
    templateUrl: 'administration.component.html',
    styleUrls: ['administration.component.scss']
})
export class AdministrationComponent implements OnInit, OnDestroy {
    @Input() portalInfo: PortalInfo;
    form: UntypedFormGroup;  
    busy: boolean;
    user: User;

    activeUserSub: Subscription;

    constructor(
        private sessionService: SessionService) {}

    ngOnInit() {
        this.activeUserSub = this.sessionService.activeUser.subscribe((user: User) => {
            this.user = user;
        });
    } 

    ngOnDestroy() {
        this.activeUserSub.unsubscribe();
    }
}
